// extracted by mini-css-extract-plugin
export default {"footer":"Ihyjv5a6aAgYSSZ","inner":"dHg9cYSKmsVilwp"};